import { useSiteSettings } from '@monorepo/site-settings';

const useGetOfficeMenu = () => {
  const { officeMenu = [] } = useSiteSettings();

  return officeMenu;
};

export default useGetOfficeMenu;
